/* eslint-disable */
import { useEffect, useState } from "react";
import DivStyle from "../../components/style/div.component";
import API from "../../api/api";
import AdminAPI from "../../api/admin";
import ButtonStyle from "../../components/style/button.component";
import Page from "../../components/table/paging";
import Table from "../../components/table/Table";
import ExcelJS from "exceljs";
import FileSaver from "file-saver";
import { Header } from "../../components/table/interface/interface";
import {
  IFriendRecommend,
  IRewardRecord,
  IToPointAndRebuy,
  IUserCount,
} from "./interface/interface";
import GameAPI from "../../api/game";
import { DASHBOARD_CONFIG, DASHBOARD_HEADERS } from "./constants";
import {
  numberFormat,
  getCurrentDateString,
  getDaysBetweenDates,
  addDays,
} from "./utils";

const DashBoard = () => {
  const [dataList, setDataList] = useState<IUserCount[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  let totalCount = 0;
  let totalExitCount = 0;
  let totalDayExitCount = 0;
  let totalDailyRecommendCount = 0;

  const getUserCount = async (): Promise<IUserCount[]> => {
    const startDate = DASHBOARD_CONFIG.START_DATE;
    const endDate = getCurrentDateString();
    const data = {
      startDate,
      endDate,
    };
    const [userCounts, exitList, dayExitList, dailyRecommendList] =
      await Promise.all([
        API.getUserCount(data),
        getExitUserCount(),
        getDayExitUserCount(),
        getDailyRecommendCount(),
      ]);
    const list = userCounts.sort(
      (a: IUserCount, b: IUserCount) =>
        new Date(a.date).getTime() - new Date(b.date).getTime()
    );
    const start: Date = new Date(list[0].date);
    const end: Date = new Date(endDate);

    const count = getDaysBetweenDates(start, end);
    const sortedFullList: IUserCount[] = [
      {
        date: "Total (Avg.)",
        userCount: 0,
        exitUserCount: 0,
        dayExitUserCount: 0,
        dailyRecommendCount: 0,
        gameMoney: 0,
        manualGameMoney: 0,
        prizeGameMoney: 0,
        couponGameMoney: 0,
        attendancePoint: 0,
        freeCharge: 0,
        newUserBonus: 0,
        clubJoin: 0,
        friendRecommend: 0,
      },
    ];

    for (let index = count; index >= 0; index--) {
      const currentDate = addDays(start, index);
      const currentDateStr = currentDate.toISOString().slice(0, 10);
      const existingItem = list.find(
        (item: IUserCount) => item.date === currentDateStr
      );
      const exitUserItem = exitList.find(
        (item: IUserCount) => item.date === currentDateStr
      );
      const dayExitUserItem = dayExitList.find(
        (item: IUserCount) => item.date === currentDateStr
      );
      const dailyRecommendItem = dailyRecommendList.find(
        (item: IUserCount) => item.date === currentDateStr
      );
      const exitUserCount = exitUserItem ? exitUserItem.userCount : 0;
      const dayExitUserCount = dayExitUserItem ? dayExitUserItem.userCount : 0;
      const dailyRecommendCount = dailyRecommendItem
        ? dailyRecommendItem.userCount
        : 0;
      if (existingItem) {
        existingItem.exitUserCount = exitUserCount;
        existingItem.dayExitUserCount = dayExitUserCount;
        existingItem.dailyRecommendCount = dailyRecommendCount;
        sortedFullList.push(existingItem);
      } else {
        sortedFullList.push({
          date: currentDateStr,
          userCount: 0,
          exitUserCount: exitUserCount,
          dayExitUserCount: dayExitUserCount,
          dailyRecommendCount: dailyRecommendCount,
          gameMoney: 0,
          manualGameMoney: 0,
          prizeGameMoney: 0,
          couponGameMoney: 0,
          attendancePoint: 0,
          freeCharge: 0,
          newUserBonus: 0,
          clubJoin: 0,
          friendRecommend: 0,
        });
      }
    }

    totalCount = 0;
    totalExitCount = 0;
    totalDayExitCount = 0;
    totalDailyRecommendCount = 0;
    dailyRecommendList.map((data) => {
      totalDailyRecommendCount += +data.userCount;
      return totalDailyRecommendCount;
    });
    dayExitList.map((data) => {
      totalDayExitCount += +data.userCount;
      return totalDayExitCount;
    });
    exitList.map((data) => {
      totalCount += +data.userCount;
      totalExitCount += +data.userCount;
      return totalExitCount;
    });
    sortedFullList.map((data) => {
      totalCount += +data.userCount;
      return totalCount;
    });

    return sortedFullList;
  };

  const getExitUserCount = async (): Promise<IUserCount[]> => {
    const startDate = DASHBOARD_CONFIG.EXIT_START_DATE;
    const endDate = getCurrentDateString();
    const data = {
      startDate,
      endDate,
    };
    const userCounts = (await API.getExitUserCount(data)).sort(
      (a: IUserCount, b: IUserCount) =>
        new Date(a.date).getTime() - new Date(b.date).getTime()
    );
    return userCounts;
  };

  const getDayExitUserCount = async (): Promise<IUserCount[]> => {
    const startDate = DASHBOARD_CONFIG.EXIT_START_DATE;
    const endDate = getCurrentDateString();
    const data = {
      startDate,
      endDate,
    };
    const userCounts = (await API.getDayExitUserCount(data)).sort(
      (a: IUserCount, b: IUserCount) =>
        new Date(a.date).getTime() - new Date(b.date).getTime()
    );
    return userCounts;
  };

  const getDailyRecommendCount = async (): Promise<IUserCount[]> => {
    const startDate = DASHBOARD_CONFIG.EXIT_START_DATE;
    const endDate = getCurrentDateString();
    const data = {
      startDate,
      endDate,
    };
    const userCounts = (await API.getDailyRecommendCount(data)).sort(
      (a: IUserCount, b: IUserCount) =>
        new Date(a.date).getTime() - new Date(b.date).getTime()
    );
    return userCounts;
  };

  const exportToExcel = async (headers: Header[], items: IUserCount[]) => {
    const today = getCurrentDateString();
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Data");

    worksheet.addRow(headers.map((header) => header.text));

    items.forEach((item: IUserCount | any) => {
      const rowValues = headers.map((header) => {
        if (header.value === "createdAt") {
          return item[header.value].split("T")[0];
        } else {
          return item[header.value];
        }
      });
      worksheet.addRow(rowValues);
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    FileSaver.saveAs(blob, "all_report" + "_" + today + ".xlsx");
  };

  const getUserStatistics = async () => {
    try {
      const [
        userList,
        friendRecommendList,
        gameDashboard,
        attendanceDashboard,
      ] = await Promise.all([
        getUserCount(),
        API.getFriendRecommend(),
        GameAPI.getGameDashboard(),
        AdminAPI.getAttendanceDashboard(),
      ]);
      let totalGameMoney = DASHBOARD_CONFIG.INITIAL_TOTAL_GAME_MONEY;
      let totalManualGameMoney =
        DASHBOARD_CONFIG.INITIAL_TOTAL_MANUAL_GAME_MONEY;
      let totalPrizeGameMoney = 0;
      let totalCouponGameMoney = 0;
      let totalAttendancePoint = 0;
      let totalFreeCharge = 0;
      let totalNewUserBonus = 0;
      let totalClubJoin = 0;

      for (let index = 1; index < userList.length; index++) {
        const currentDateStr = userList[index].date;
        let currentGameMoney = 0;
        let currentDailyRecommendUserCount = 0;
        let currentManualGameMoney = 0;
        let currentPrizeGameMoney = 0;
        let currentCouponGameMoney = 0;
        let currentAttendancePoint = 0;
        let currentFreeCharge = 0;
        let currentNewUserBonus = 0;
        let currentClubJoin = 0;

        const currentDateFriendList =
          friendRecommendList?.filter(
            (item: IFriendRecommend) => item.date === currentDateStr
          ) || [];
        const currentDateRecommendList = currentDateFriendList;

        const manualDateList = currentDateFriendList.filter(
          (item: IFriendRecommend) => item.isAdmin
        );
        const currentDatePrize = gameDashboard.find(
          (item: any) => item.date === currentDateStr
        );

        const currentDateAttendance = attendanceDashboard.find(
          (item: any) => item.date === currentDateStr
        );

        if (currentDatePrize) {
          currentPrizeGameMoney = currentDatePrize.prize;
          currentCouponGameMoney = currentDatePrize.coupon;
          totalPrizeGameMoney += currentPrizeGameMoney;
          totalCouponGameMoney += currentCouponGameMoney;
          currentFreeCharge = currentDatePrize.freeCharge;
          currentNewUserBonus = currentDatePrize.newUserBonus;
          currentClubJoin = currentDatePrize.clubJoin;
          totalFreeCharge += currentFreeCharge;
          totalNewUserBonus += currentNewUserBonus;
          totalClubJoin += currentClubJoin;
        }

        if (currentDateAttendance) {
          currentAttendancePoint = currentDateAttendance.point;
          totalAttendancePoint += currentAttendancePoint;
        }

        manualDateList.forEach((obj: IFriendRecommend) => {
          currentManualGameMoney += obj.adminGameMoney;
        });

        currentDateRecommendList.forEach((obj: IFriendRecommend) => {
          currentDailyRecommendUserCount += obj.count;
          currentGameMoney += obj.totalGameMoney;
        });

        userList[index].dailyRecommendCount = numberFormat(
          currentDailyRecommendUserCount
        );
        userList[index].gameMoney = numberFormat(currentGameMoney);
        userList[index].manualGameMoney = numberFormat(currentManualGameMoney);
        userList[index].prizeGameMoney = numberFormat(currentPrizeGameMoney);
        userList[index].couponGameMoney = numberFormat(currentCouponGameMoney);
        userList[index].attendancePoint = numberFormat(currentAttendancePoint);
        userList[index].freeCharge = numberFormat(currentFreeCharge);
        userList[index].newUserBonus = numberFormat(currentNewUserBonus);
        userList[index].clubJoin = numberFormat(currentClubJoin);
        totalManualGameMoney += currentManualGameMoney;
        totalGameMoney += currentGameMoney;
      }

      userList[0].userCount = numberFormat(totalCount);
      userList[0].exitUserCount = numberFormat(totalExitCount);
      userList[0].dayExitUserCount = numberFormat(totalDayExitCount);
      userList[0].dailyRecommendCount = numberFormat(totalDailyRecommendCount);
      userList[0].gameMoney = numberFormat(totalGameMoney);
      userList[0].manualGameMoney = numberFormat(totalManualGameMoney);
      userList[0].prizeGameMoney = numberFormat(totalPrizeGameMoney);
      userList[0].couponGameMoney = numberFormat(totalCouponGameMoney);
      userList[0].attendancePoint = numberFormat(totalAttendancePoint);
      userList[0].freeCharge = numberFormat(totalFreeCharge);
      userList[0].newUserBonus = numberFormat(totalNewUserBonus);
      userList[0].clubJoin = numberFormat(totalClubJoin);
      setDataList(userList);
      const totalPages = Math.ceil(
        userList.length / DASHBOARD_CONFIG.PAGE_SIZE
      );
      setTotalPages(totalPages);
      setDataList(userList);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getPubGradesClosingInThreeDays = async () => {
    const res = await AdminAPI.getPubGradesClosingInThreeDays();

    if (res.length > 0) {
      alert(res + " 플랜 종료일 3일 이내로 남았습니다.");
    }
  };

  useEffect(() => {
    getUserStatistics();
    getPubGradesClosingInThreeDays();
  }, []);

  return (
    <>
      <DivStyle
        style={{ overflow: "auto" }}
        backgroundColor="#121212"
        height="100vh"
        display="flex"
        flex_direction="column"
        align_items="center"
        marginTop="65px"
      >
        <h2 style={{ color: "white", width: "95%", marginTop: "40px" }}>
          RunnerRunner DashBoard
        </h2>
        <DivStyle
          width="95%"
          display="flex"
          backgroundColor="#1E1E1E"
          flex_direction="column"
          borderRadius="10px"
          marginTop="30px"
          marginBottom="60px"
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <ButtonStyle
              fontWeight="700"
              backgroundColor="#272727"
              border="none"
              borderRadius="7px"
              marginTop="20px"
              width="85px"
              height="40px"
              color="white"
              marginRight="20px"
              onClick={() => exportToExcel(DASHBOARD_HEADERS, dataList)}
            >
              TOEXCEL
            </ButtonStyle>
          </div>
          <Table
            headers={DASHBOARD_HEADERS}
            currentPage={currentPage}
            dataList={dataList}
          />
          <Page
            currentPage={currentPage}
            totalPages={totalPages}
            dataList={dataList}
            setCurrentPage={setCurrentPage}
          />
        </DivStyle>
      </DivStyle>
    </>
  );
};

export default DashBoard;
